export const GOAL_TYPE = {
  UNDER_ME_NEXT_SKILL: 'underMeNextSkill',
  CUSTOM: 'custom'
};
